import CartListTitle from './CartListTitle';
import CartOrderList from './CartOrderList';
import CartTotal from './CartTotal';
import './CartList.css';

export default function CartList({ pagedata }) {
  return (
    <div className="CartList">
      <CartListTitle pagedata={pagedata} />
      <CartOrderList pagedata={pagedata} />
      <CartTotal pagedata={pagedata}/>
    </div>
  )
}
